import { type as types } from "../types/index";

const initialState = {isSucursal: false, isLoading: false, isFetched: false, dataSucursales: [] };

export const SucursalReducer = (state = initialState, action) => {

    const {type, payload } = action;

    switch (type) {
        case types.getSucursales:
            const result = {
                ...state,
                isSucursal: true,
                isFetched: true,
                dataSucursales: payload
            };
            return result;

        case types.getSucursalesFail:
            return {
                ...state,
                isSucursal: false,
                isFetched: true,
                dataSucursales: []
            }
        default:
            return state;
    }

}